var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component } from "vue-facing-decorator";
import { State, Action } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { LeftMenuState } from "@/common/enums/left-menu-state";
let TopMenuVue = class TopMenuVue extends Vue {
    constructor() {
        super(...arguments);
        this.showProfileLink = false;
    }
    created() {
        if (this.loginState.leftMenuState == LeftMenuState.Collapsed)
            this.setMenuVisibility();
    }
    ;
    menuClick() {
        let leftMenuState = this.leftMenuState;
        this.setMenuVisibility();
        this.setLeftMenuState(leftMenuState);
    }
    ;
    setMenuVisibility() {
        let $body = this.body;
        let $sidebarMenu = document.getElementById("sidebar-menu");
        if (!$sidebarMenu || !$body)
            return;
        let hide = $body.classList.contains("nav-md") ? true : false;
        document.querySelectorAll("li.active").forEach($element => {
            let $menus = $element.getElementsByTagName("ul");
            for (let i = 0; i < $menus.length; i++)
                $menus[i].style.display = hide ? "none" : "block";
        });
        let classes = ["nav-md", "nav-sm"];
        classes.forEach(css => $body.classList.toggle(css));
    }
    ;
    get body() {
        return document.getElementsByTagName("body")[0];
    }
    ;
    get leftMenuState() {
        let $body = this.body;
        if (!$body)
            return LeftMenuState.Expanded;
        return $body.classList.contains("nav-md") ? LeftMenuState.Collapsed : LeftMenuState.Expanded;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], TopMenuVue.prototype, "loginState", void 0);
__decorate([
    Action("setLeftMenuState", { namespace: "loginModule" }),
    __metadata("design:type", Object)
], TopMenuVue.prototype, "setLeftMenuState", void 0);
TopMenuVue = __decorate([
    Component({
        name: "TopMenuVue"
    })
], TopMenuVue);
export default TopMenuVue;
